import { useStore } from "@nanostores/react";
import type { Addons, CartItems, GlobalContent } from "@wbly/data-storefront";
import { Loading } from "@wbly/ui";
import { CartItem } from "../CartItem";
import { cartDetails } from "../../../pages/[locale]/cart/stores/details.store";
import styles from "./CartItems.module.css";

export type CartItemsProps = {
  staticContent: CartItems & Addons & GlobalContent;
  marketplace: string;
};

export function CartItems({ staticContent, marketplace }: CartItemsProps) {
  const $cartDetails = useStore(cartDetails);

  // Don't render anything if empty or it'll double the gap between the other elements
  if ($cartDetails.status === "success" && !$cartDetails.data) {
    return null;
  }

  return (
    <section className={styles.CartItems}>
      <div
        data-testid="cart-line-items"
        className={[
          styles["CartItems-items"],
          styles[`CartItems-items--${$cartDetails.status}`],
        ].join(" ")}
      >
        {$cartDetails.status === "loading" && (
          <Loading
            relative={!$cartDetails.data}
            absolute={!!$cartDetails.data}
            black
          />
        )}

        {$cartDetails.data?.order.items.map((cartItem) => (
          <CartItem
            key={cartItem.solidus.id}
            staticContent={staticContent}
            marketplace={marketplace}
            {...cartItem}
          />
        ))}
      </div>
    </section>
  );
}
